<template>
  <div id="traza-contratos">
    <v-container grid-list-xl fluid>
      <div v-if="loading">
        <loading></loading>
      </div>
      <template><v-layout justify-center>
          <v-flex xs12 md3>
            <v-select v-model="tipoValue" :items="tipoSelect" label="Tipo" item-text="nombre" item-value="code">
            </v-select>
          </v-flex>
          <v-flex xs12 md3>
            <v-text-field v-model="nombreValue" label="Nombre y Apellido"></v-text-field>
          </v-flex>
          <v-flex xs12 md3>
            <v-select v-model="moduloValue" :items="moduloSelect" label="Módulo" item-text="descripcion"
              item-value="id">
            </v-select>
          </v-flex>
          <v-btn fab dark color="teal" title="Filtrar detalle" @click="loadData(true)">
            <v-icon dark>filter_list</v-icon>
          </v-btn>
          <v-btn fab dark color="red darken-4" title="Limpiar filtros" @click="clear()">
            <v-icon dark>clear_all</v-icon>
          </v-btn>
        </v-layout>
        <v-layout justify-center>
          <v-flex lg12>
            <v-card-actions class="pb-3">
              <v-spacer></v-spacer>
            </v-card-actions>
            <v-data-table :headers="headers" :items="itemsTraza" :rows-per-page-items="rowsPerPageItems"
              class="elevation-1" hide-actions>
              <template v-slot:items="props">
                <td class="text-xs-left">{{ props.item.fecha }}</td>
                <td class="text-xs-left">{{ props.item.usuario.tipo }}</td>
                <td class="text-xs-left">
                  {{ props.item.usuario.nombre }}
                  {{ props.item.usuario.apellido }}
                </td>
                <td class="text-xs-left">
                  <template>
                    <v-expansion-panel>
                      <v-expansion-panel-content>
                        <template v-slot:header>
                          <div>{{ props.item.modulo.descripcion }}</div>
                        </template>
                        <v-card>
                          <v-simple-table dense>
                            <tbody>
                              <tr>
                                <td><strong>Código:</strong></td>
                                <td>{{ props.item.modulo.codigo }}</td>
                              </tr>
                              <tr>
                                <td><strong>Descripción:</strong></td>
                                <td>{{ props.item.modulo.descripcion }}</td>
                              </tr>
                              <tr>
                                <td><strong>Proceso:</strong></td>
                                <td>{{ props.item.modulo.proceso.codigo }} - {{ props.item.modulo.proceso.descripcion }}
                                </td>
                              </tr>
                            </tbody>
                          </v-simple-table>
                        </v-card>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </template>

                </td>
                <td class="text-xs-left">{{ props.item.accion.nombre }}</td>
              </template>
            </v-data-table>

            <!-- paginacion -->
            <v-flex xs12 sm6>
              <v-text-field value="" label="Total de Registros" v-model="totalRegs" disabled></v-text-field>
            </v-flex>
            <div class="text-center pt-2">
              <v-pagination @input="changePage(page)" v-model="page" :length="pages" :total-visible="9" circle>
              </v-pagination>
            </div>
          </v-flex>
        </v-layout>
      </template>
    </v-container>
  </div>
</template>

<script>

import axios from "axios";
import Loading from "@/views/ui/Loading.vue";
import jwtDecode from "jwt-decode";
import { VSimpleTable } from 'vuetify/lib';
export default {
  name: "traza-contratos",
  components: {
    Loading,
    VSimpleTable,
  },
  props: {},
  data: (vm) => ({
    // return {
    loading: false,
    idContrato: null,
    idUsuario: null,
    nombreUsuario: "",
    apellidoUsuario: "",
    rowsPerPageItems: [20],
    pagination: {
      rowsPerPage: 20,
    },
    userTipo: "",
    itemsTraza: [],
    headers: [
      { text: "Fecha", sortable: false, value: "items.fecha" },
      {
        text: "Tipo",
        align: "left",
        sortable: false,
        value: "items.usuario.tipo",
      },
      {
        text: "Usuario",
        align: "left",
        sortable: false,
        value: "items.usuario.nombre",
      },
      { text: "Modulo", sortable: false, value: "items.modulo.descripcion" },
      { text: "Acción", sortable: false, value: "items.accion.nombre" },
      // { text: "Descripción", sortable: false, value: "items.descripcion" },
    ],
    //filtros
    tipoValue: "",
    tipoSelect: [
      { nombre: "Agencia", code: 0 },
      { nombre: "Proveedor", code: 1 },
      { nombre: "Administrador", code: 2 },
    ],
    nombreValue: "",
    moduloValue: "",
    moduloSelect: [],

    //paginacion DB
    page: 0,
    pages: 0,
    totalRegs: 0,
  }),
  created() {

    this.userTipo = this.$store.getters.userLogged.tipo;
    this.idContrato = this.$store.getters.contratoStored;
    this.idUsuario = this.$store.getters.userLogged.id;
    if (this.userTipo == undefined || this.userTipo == null) {

      let token = localStorage.getItem("token");
      const decodedToken = jwtDecode(token);
      const userDto = decodedToken.dto;
      this.userTipo = userDto.tipo;
      this.idUsuario = userDto.id;
      this.nombreUsuario = userDto.nombre;
      this.apellidoUsuario = userDto.apellido;
    }
    if (!this.idContrato) {
      this.idContrato = localStorage.getItem("idContrato");
    }

    console.log("idContrato::" + this.idContrato);
    console.log("userTipo::" + this.userTipo);
    if (this.idContrato == null || this.idContrato == undefined) {
      this.$router.replace({ path: "/loginNew" });
    }
    this.loadModulos();
  },
  mounted() {
    this.loadData();
  },
  methods: {
    convertirTipoUsuario(tipo) {
      const tipoEncontrado = this.tipoSelect.find(t => t.nombre.toUpperCase() === tipo);
      return tipoEncontrado ? tipoEncontrado.code : null;
    },
    async loadTraza() {
      let body = {
        idContrato: this.idContrato,
        idUsuario: this.idUsuario,
        tipoUser: this.tipoValue,
        nombreUser: this.nombreValue,
        idModulo: this.moduloValue,
        pageSize: 20,
        pageNumber: this.page,
      };
      return await axios
        .post("/trazaContrato/" + this.idContrato, body)
        .then(function (response) {
          console.log("response.data::", response.data);
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            /*  window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message); */
          }
          return [];
        });
    },
    async loadData(limpiar) {
      if (limpiar) this.page = 0;
      this.loading = true;
      let result = await this.loadTraza();

      this.itemsTraza = result.trazas;
      console.log("this.itemsTraza::" + this.itemsTraza.length);
      if (result.totalRegistros > 0) {
        this.totalRegs = result.totalRegistros;
        this.pages = Math.ceil(this.totalRegs / this.rowsPerPageItems);
      } else {
        this.totalRegs = 0;
        this.page = 0;
        this.pages = 0;
      }
      this.loading = false;
    },
    changePage(page) {
      // Si hay solo una página, forzar a quedarse en la page 0
      if (this.pages <= 1) {
        this.page = 0;
      } else {
        this.page = page <= 0 || page > this.pages ? this.page : page;
      }
      console.log("page::" + this.page);
      this.loadData();
    },

    clear() {
      this.tipoValue = "";
      this.nombreValue = "";
      this.moduloValue = "";
      this.loadData(true);
    },
    async loadListaModulos() {
      return await axios
        .post("/trazaContrato/loadListaModulos/" + this.idContrato)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log("error: loadListaModulos:" + error.response);
          }
          return -1;
        });
    },
    async loadModulos() {
      this.moduloSelect = await this.loadListaModulos();
    },
  },
};
</script>
